$.fx.speeds._default = 200;

(function($) {
  'use strict';

  var init = {
    dom: function() {
      this.$html          = $('html');
      this.$header        = $('#header');
      this.$dummyHeader   = $('[data-js-hook="header-dummy"]');
      this.$hasSubnav     = $('.has-subnav');
      this.$hasSubmenu     = $('.has-submenu');
      this.$toggleMenu    = $('[data-js-hook="menu-toggle"]');
      this.$flyoutNav     = $('#flyout-nav');
      this.$lazyImage     = $('.lazyload');
      this.$lazyEmbed     = $('.lazyembed');
      this.$truncation    = $('[data-truncate]');
      this.$rotator       = $('[data-rotator]');
      this.$carousel      = $('[data-carousel]');
      this.$accordion     = $('[data-accordion]');
      this.$stickyElement = $('[data-sticky-element]');
      this.$accordionToggle = $('[data-accordion-toggle]');
    },

    settings: {
      windowWidth: window.innerWidth,
      headerHeight: 0,
      headerOffset: 0,
    },

    stickyHeader: function() {
      var paletteDefault    = init.$header.attr('data-palette');
      var paletteBgDefault  = init.$header.attr('data-palette-bg');
      var paletteOverride   = init.$header.attr('data-sticky-palette');
      var paletteBgOverride = init.$header.attr('data-sticky-palette-bg');

      // added because occasionally window load finishes before init.dom() can be executed
      if (typeof init.$header == 'undefined') {
        init.dom();
      }

      var resizeHeader = false;
      if (!event || init.settings.headerHeight == 0)  {
        resizeHeader = true;
      }
      else if (event.type == 'resize' && init.settings.windowWidth != window.innerWidth) {
        resizeHeader = true;
      }

      if (jcms.stickyHeader && init.$header.length) {
        if (resizeHeader && init.$dummyHeader.length) {
          init.settings.headerHeight = init.$header.height();
          init.$dummyHeader.height(init.settings.headerHeight);
          init.settings.windowHeight = window.innerHeight;
        }

        if ($(window).scrollTop() > init.settings.headerOffset) {
          $('html').addClass('header-stuck');
          if (paletteOverride) {
            init.$header.removeClass(paletteDefault).addClass(paletteOverride);
          }
          if (paletteBgOverride) {
            init.$header.css('background-color', paletteBgOverride);
          }
        }
        else {
          $('html').removeClass('header-stuck');
          if (paletteOverride) {
            init.$header.removeClass(paletteOverride).addClass(paletteDefault);
          }
          if (paletteBgOverride) {
            init.$header.css('background-color', paletteBgDefault);
          }
        }
      }
    },

    headerActions: function() {
      this.$hasSubnav
        .mouseenter(function() {
          $(this).addClass('hover');
        })
        .mouseleave(function() {
          $(this).removeClass('hover');
        });

      this.$hasSubmenu.click(function(event) {
        event.preventDefault();
        $(this).toggleClass('active').next('.flyout-nav__menu-sub').slideToggle();
      });

      this.$toggleMenu.click(function(event) {
        event.preventDefault();
        init.$flyoutNav.fadeToggle();
        $('html').toggleClass('menu-open');
      });
    },

    lazyAssets: function() {
      this.$lazyImage.lazyload();

      this.$lazyEmbed.lazyload({
        type: 'embed',
      });
    },

    fancybox: function() {
      $('[target="embed"]').each(function(){
        var url = $(this).attr('href');

        $(this).attr('data-type', 'iframe').attr('data-src', url).attr('href', '');
      });

      $('[data-fancybox],[target="popup"],[target="embed"],[target="video"]').fancybox({
        hash: false,
        infobar: false,
        idleTime: 60,
        loop: true,
        transitionEffect: "slide",
        buttons: [
          "close"
        ],
        btnTpl: {
          // Arrows
          arrowLeft:
            '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
            '<div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="14.07 6 8 12.07 14.07 18.14 15.57 16.64 11 12.07 15.57 7.5 14.07 6"/></svg></div>' +
            "</button>",
          arrowRight:
            '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
            '<div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="9.5 6 8 7.5 12.57 12.07 8 16.64 9.5 18.14 15.57 12.07 9.5 6"/></svg></div>' +
            "</button>",
        },
        wheel: false
      });
    },

    truncation: function() {
      this.$truncation.each(function() {
        var $this = $(this);
        var readMoreTemplate = '&nbsp;<span data-js-hook="truncate-toggle" class="link read-more read-more--more">Read More</span>';
        var readLessTemplate = '&nbsp;<span data-js-hook="truncate-toggle" class="link read-more read-more--less">Read Less</span>';
        var iLimit = $this.data('truncate') ? $this.data('truncate') : 500;
        var iLength = $this.text().length;

        if (iLength > iLimit && $this.html().substr(iLimit - iLength).trim()) {
          var text = $this.html().substr(0, iLimit);
          var $clone = $this.clone();
          $this.attr('aria-hidden','true').html(text).append(readMoreTemplate);
          $this.after($clone.attr('aria-hidden','false').append(readLessTemplate).hide());
        }

        // -- Can't cache. Must bind after DOM injection.
        $('[data-js-hook="truncate-toggle"]').bind('click', function(e){
          e.preventDefault();
          $(this).parent().hide();
          $(this).parent().siblings().show();
        });
      });
    },

    rotator: function() {
      this.$rotator.each(function() {
        var $this = $(this);
        var options = $this.data('rotator').split(',');
        var controlNav = options.indexOf('control') != -1;
        var directionNav = options.indexOf('direction') != -1;
        var directionClass = typeof $this.attr('data-rotator-direction') != 'undefined' ? $this.data('rotator-direction') : 'palette-primary';

        $this.find('.lazyload:not(.lazyload--loaded)').lazyload({force: true});

        $this.on('init', function(event, slick){
          if (directionNav) {
            slick.$nextArrow.addClass(directionClass);
            slick.$prevArrow.addClass(directionClass);
          }
        });

        $this.slick({
          infinite: true,
          dots: controlNav,
          arrows: directionNav
        });
      });
    },

    carousel: function() {
      this.$carousel.each(function() {
        var $this = $(this);
        var items = $this.data('carousel');
        var padding = $this.data('carousel-padding');
        var slideAnim = $this.attr('data-carousel-fade') ? $this.data('carousel-fade') : true;
        var loop = $this.attr('data-carousel-loop') ? $this.data('carousel-loop') : true;

        $this.addClass('owl-carousel owl-theme').owlCarousel({
          dots: false,
          nav: true,
          loop: loop,
          mouseDrag: false,
          smartSpeed: 1000,
          stagePadding: padding ? padding : 0,
          responsive: {
            0: {
              dots: true,
              nav: false,
              items: items / 3 > 1 ? Math.floor(items / 3) : 1,
              margin: 15,
            },
            621: {
              dots: true,
              nav: false,
              items: Math.floor(items / 2),
              margin: 40,
            },
            809: {
              items: items,
              margin: 40,
            },
            981: {
              items: items,
              margin: 60,
            }
          },
          onInitialized: function(event) {
            var index = event.item.index;
            var last = Math.floor(event.page.size);
            var $next = $('.owl-item', $this).eq(index + last);
            var $nextImage = $next.find('.lazyload');

            if (slideAnim) {
              $('.owl-item', $this).eq(index + last).addClass('sliding');
            }

            if ($nextImage.length && $nextImage.attr('data-src')) {
              var src = $nextImage.attr('data-src');
              $nextImage.attr('src', src).removeAttr('data-src');
            }
          },
          onTranslate: function(event) {
            var index = event.item.index;
            var last = Math.floor(event.page.size);
            var $prev = $('.owl-item', $this).eq(index - 1);
            var $prevImage = $prev.find('.lazyload');
            var $next = $('.owl-item', $this).eq(index + last);
            var $nextImage = $next.find('.lazyload');

            if (slideAnim) {
              $('.owl-item', $this).eq(index + last - 1).removeClass('sliding');
              $next.addClass('sliding');
              $('.owl-item', $this).eq(index - 1).addClass('sliding');
            }

            if ($prevImage.length && $prevImage.attr('data-src')) {
              var prevSrc = $prevImage.attr('data-src');
              $prevImage.attr('src', prevSrc).removeAttr('data-src');
            }

            if ($nextImage.length && $nextImage.attr('data-src')) {
              var nextSrc = $nextImage.attr('data-src');
              $nextImage.attr('src', nextSrc).removeAttr('data-src');
            }
          },
          onTranslated: function(event) {
            var index = event.item.index;
            var last = Math.floor(event.page.size);
            var $next = $('.owl-item', $this).eq(index + last);
            var $nextImage = $next.find('.lazyload');

            if (slideAnim) {
              $('.owl-item', $this).removeClass('sliding');
              $next.addClass('sliding');
            }

            if ($nextImage.length && $nextImage.attr('data-src')) {
              var src = $nextImage.attr('data-src');
              $nextImage.attr('src', src).removeAttr('data-src');
            }
          }
        });
      });
    },

    accordion: function() {
      this.$accordion.each(function() {
        var $this = $(this);
        var $children = $this.children('div');
        var $toggle = $children.children('button');

        $toggle.click(function(event) {
          event.stopPropagation();
          $(this).next('div').slideToggle();
          $(this).toggleClass('toggle-open');
        });
      });
    },

    popdownOverrides: function() {
      var $popdown = $('#popdown');
      var $header = $('#header');

      var popdownHeaderAdjust = function() {
        var animatedInterval;

        animatedInterval = setInterval(function() {
          if (init.$html.hasClass('popdown-open') || init.$html.hasClass('popdown-sliding')) {
            clearInterval(animatedInterval);
            $header.css('cssText', 'position: absolute !important;');
            init.settings.headerOffset = init.$dummyHeader.offset().top + init.$dummyHeader.height();
          }
        }, 200);
      };

      $('#popdownToggle').click(function() {
        $('html, body').animate({scrollTop: 0}, 100, function() {
          popdownHeaderAdjust();
          $('html').removeClass('show-popdown');
        });
      });

      if ($popdown.length && jcms.stickyHeader) {
        var skipInitialAdjustment = $popdown.hasClass('popdown--3') && !$popdown.data('show-popdown');

        var $button = $popdown.find('.popdown__button');

        if ($button.length) {
          $button.addClass('button').removeClass('popdown__button').html('<span class="offset">' + $button.text() + '</span>');
        }

        if (!skipInitialAdjustment) {
          popdownHeaderAdjust();
        }

        $(window).on('load scroll', function() {
          var offset = $(window).scrollTop() - $popdown.outerHeight();
          var skipHeaderCSS = $popdown.hasClass('popdown--3') && !$popdown.data('show-popdown');

          if (offset >= 0 || !$popdown.is(':visible')) {
            $('html').removeClass('show-popdown');
            $header.css('position', '');
          }
          else if (!skipHeaderCSS) {
            $header.css('cssText', 'position: absolute !important;');
          }

          init.settings.headerOffset = init.$dummyHeader.offset().top + init.$dummyHeader.height();
        });
      }
    },

    stickyElement: function() {
      this.$stickyElement.each(function() {
        var $this = $(this);
        var $parent = $this.parent();
        var $window = $(window);
        var height = $this.outerHeight();

        $this.addClass('sticky');

        $window.on('load scroll resize', function() {
          var parentOffsetTop = $parent.offset().top;
          var parentOffsetBottom = parentOffsetTop + $parent.outerHeight();
          var windowOffset = $window.scrollTop();
          var windowOffsetBottom = windowOffset + window.innerHeight;

          if ( windowOffsetBottom >= parentOffsetBottom ) {
            $this.addClass('relative relative--bottom');
          }
          else if ( windowOffsetBottom <= parentOffsetTop + height) {
            $this.addClass('relative relative--top');
          }
          else {
            $this.removeClass('relative relative--top relative--bottom');
          }
        });
      });
    },

    accordionToggle: function() {
      this.$accordionToggle.click(function(event) {
        event.preventDefault();
        var id = $(this).data('accordion-toggle');
        var $parent = $(this).parent().parent();
        if ($parent.hasClass('active')) {
          $parent.removeClass('active');
          $('[data-accordion-id]').slideUp();
        }
        else {
          $parent.addClass('active');
          $('[data-accordion-id]').slideUp().filter('[data-accordion-id="' + id + '"]').slideDown();
        }
      });
    },

    ready: function() {
      this.dom();
      this.stickyHeader();
      this.headerActions();
      this.lazyAssets();
      this.fancybox();
      this.truncation();
      this.rotator();
      this.carousel();
      this.accordion();
      this.popdownOverrides();
      this.stickyElement();
      this.accordionToggle();
    }
  };

  $(function() {
    init.ready();
  });

  $(window).on('load resize scroll', function() {
    init.dom();
    init.stickyHeader();
  });

})(jQuery);
